
import View from './View'

const Container = ({ data, uuId }) => {
  const idCliente = data?.id_cliente?.id
  const idContrato = uuId

  return (
    <View
      title="Display Editar endereço"
      data={data}
      idContrato={idContrato}
      idCliente={idCliente}
    />
  )
}

export default Container
